import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';

import ButtonBase from '$app-web/ui-kit/components/button-base';

import classes from './styles.module.scss';

import { FontAwesomeIcon } from '$common/fontawesome-pro/react-fontawesome';

// TODO: This component should be replaced with the IconButton component.
const ChatIconButton = (props) => {
    const { className, color, disabled, icon, size, fill, ...restProps } = props;

    let iconSize = 'lg';
    if (size === 'small') {
        iconSize = '1x';
    } else if (size === 'large') {
        iconSize = '2x';
    }

    return (
        <ButtonBase
            className={clsx(classes.root, classes[size], classes[color], { [classes.fill]: fill }, className)}
            disabled={disabled}
            {...restProps}
        >
            <FontAwesomeIcon icon={icon} size={iconSize} />
        </ButtonBase>
    );
};

ChatIconButton.defaultProps = {
    className: undefined,
    color: 'primary',
    disabled: false,
    size: 'medium',
    fill: false,
};

ChatIconButton.propTypes = {
    icon: PropTypes.arrayOf(PropTypes.string).isRequired,
    className: PropTypes.string,
    color: PropTypes.oneOf(['primary', 'primary-dark', 'secondary', 'success', 'error']),
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
    fill: PropTypes.bool,
};

export default ChatIconButton;
